// extracted by mini-css-extract-plugin
module.exports = {"blog":"styles_blog__HjLqk"};